module.exports = __webpack_public_path__ + "static/media/NicePng_close-button-png_521935.4afb95d0.png";